import type { EmptyStateProps } from '@/components/ui/EmptyState'
import UpgradeRequired from '@/features/subscriptions/components/UpgradeRequired'
import { subscriptionRequiredFeature } from '@/features/subscriptions/lib/paywall'

/**
 * The plan key mm-be gates every signals read on, for the refusal that does
 * not name one: a Free member's 403 carries `required_tier` and no
 * `fields.feature` (B5), and only a Shark member without the add-on gets
 * `feature: "signals"`. Upsold from the key either way, never from the tier.
 */
const SIGNALS_FEATURE = 'signals'

interface SignalsLockedProps {
  /** The refusal itself, for the feature key it may name. */
  error: unknown
  /** `page` when it replaces the whole screen, `section` inside a region. */
  size?: EmptyStateProps['size']
  framed?: boolean
}

/**
 * Signal Zone's locked state (owner decision D4): the API is Shark plus the
 * Signals add-on, so a member without it sees the app's upgrade block, not a
 * failure to retry — "Try again" would get the same 403 forever.
 *
 * Dormant until mm-be enforces plans (`SUBSCRIPTION_ENFORCEMENT_MODE`), as
 * every other gated read is; today the gate is sign-in only.
 */
export default function SignalsLocked({ error, size = 'page', framed }: SignalsLockedProps) {
  return (
    <UpgradeRequired
      featureKey={subscriptionRequiredFeature(error) ?? SIGNALS_FEATURE}
      size={size}
      {...(framed === undefined ? {} : { framed })}
    />
  )
}
